module.exports = __webpack_public_path__ + "media/images/cv/screenshot_kukumberryx-884b98ea62f9092d9d9308079d1b316f.png";